import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

const Copyright = (props) => {
  return (
    <Typography
      mb="1rem"
      mt="5rem"
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        My.BeachCam
      </Link>{" "}
      {new Date().getFullYear()}
      
    </Typography>
  );
};

export default Copyright;
